export default {
      id: "check-claim-status-usage",
      viewBox: "0 0 31 32",
      url: __webpack_public_path__ + "sprite.svg#check-claim-status",
      toString: function () {
        return this.url;
      }
    }